import { Group, Radio, Textarea } from "@mantine/core";
import React, { useEffect } from "react";
import { useForm, Controller } from "react-hook-form";

const FlightCheck = ({ setStepthree, onSubmit }) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
  } = useForm();

  const isDirectFlight = watch("isDirectFlight");
  const isEffected = watch("isEffected");
  const issueDescription = watch("issueDescription");

  // Load saved data from localStorage on component mount
  useEffect(() => {
    const savedData = localStorage.getItem("flightCheckData");
    if (savedData) {
      const parsedData = JSON.parse(savedData);

      // Set form values from localStorage
      if (parsedData.isDirectFlight) {
        setValue("isDirectFlight", parsedData.isDirectFlight);
      }
      if (parsedData.isEffected) {
        setValue("isEffected", parsedData.isEffected);
      }
      if (parsedData.issueDescription) {
        setValue("issueDescription", parsedData.issueDescription);
      }
    }
  }, [setValue]);

  // Auto-save form data to localStorage whenever it changes
  useEffect(() => {
    const subscription = watch((value) => {
      localStorage.setItem("flightCheckData", JSON.stringify(value));
    });
    return () => subscription.unsubscribe(); // Cleanup
  }, [watch]);

  // Update stepthree validation
  useEffect(() => {
    if (isDirectFlight === "true") {
      setStepthree(true);
    } else if (
      isDirectFlight === "false" &&
      isEffected === "true" &&
      issueDescription
    ) {
      setStepthree(true);
    } else if (isDirectFlight === "false" && isEffected === "false") {
      setStepthree(true);
    } else {
      setStepthree(false);
    }
  }, [isDirectFlight, isEffected, issueDescription, setStepthree]);

  const handleFormSubmit = (data) => {
    onSubmit(data); // Pass the form data to the parent component
  };

  return (
    <div className="stepper-container flight-check-wrapper">
      <h3 className="stepper-header">Connecting flight check</h3>

      <form onSubmit={handleSubmit(handleFormSubmit)} id="flight-check-form">
        <div>
          <h4 className="stepper-sub-header">
            Was this a direct flight?<span style={{ color: "red" }}> *</span>
          </h4>
          <div className="radio-options-wrapper">
            <Controller
              name="isDirectFlight"
              control={control}
              rules={{ required: "This field is required" }}
              render={({ field }) => (
                <Radio.Group {...field}>
                  <Group>
                    <Radio
                      color="red"
                      variant="outline"
                      value="true"
                      label="Yes"
                    />
                    <Radio
                      color="red"
                      variant="outline"
                      value="false"
                      label="No"
                    />
                  </Group>
                </Radio.Group>
              )}
            />
            {errors.isDirectFlight && (
              <p style={{ color: "red" }}>{errors.isDirectFlight.message}</p>
            )}
          </div>
        </div>

        {isDirectFlight === "false" && (
          <div style={{ marginTop: "30px" }}>
            <h4 className="stepper-sub-header">
              Was your connecting flight affected?
              <span style={{ color: "red" }}> *</span>
            </h4>
            <div className="radio-options-wrapper">
              <Controller
                name="isEffected"
                control={control}
                rules={{ required: "This field is required" }}
                render={({ field }) => (
                  <Radio.Group {...field}>
                    <Group>
                      <Radio
                        color="red"
                        variant="outline"
                        value="true"
                        label="Yes"
                      />
                      <Radio
                        color="red"
                        variant="outline"
                        value="false"
                        label="No"
                      />
                    </Group>
                  </Radio.Group>
                )}
              />
              {errors.isEffected && (
                <p style={{ color: "red" }}>{errors.isEffected.message}</p>
              )}
            </div>
          </div>
        )}

        {isEffected === "true" && (
          <div style={{ marginTop: "30px" }}>
            <h4
              className="sub-header"
              style={{ color: "#222222", marginBottom: "12px" }}
            >
              Tell us more about the issue
              <span style={{ color: "red" }}> *</span>
            </h4>
            <Controller
              name="issueDescription"
              control={control}
              rules={{ required: "This field is required" }}
              render={({ field }) => (
                <textarea
                  {...field}
                  rows={8}
                  onBlur={(e) => {
                    const trimmed = e.target.value.trim();
                    setValue("issueDescription", trimmed);
                  }}
                  placeholder="Briefly explain what happened"
                  error={errors.issueDescription?.message}
                />
              )}
            />
          </div>
        )}
      </form>
    </div>
  );
};

export default FlightCheck;
